export interface LoomViewerFrameScheduler {
  dispose: () => void;
  request: (advanceControls?: boolean) => void;
}

interface LoomViewerFrameSchedulerOptions {
  cancelFrame: (frameId: number) => void;
  onFrame: (advanceControls: boolean) => boolean;
  requestFrame: (callback: FrameRequestCallback) => number;
}

/** Coalesces invalidations and only continues while camera damping is active. */
export function createLoomViewerFrameScheduler({
  cancelFrame,
  onFrame,
  requestFrame,
}: LoomViewerFrameSchedulerOptions): LoomViewerFrameScheduler {
  let disposed = false;
  let frameId: number | null = null;
  let advanceControls = false;

  const request = (shouldAdvanceControls = false) => {
    if (disposed) return;
    advanceControls ||= shouldAdvanceControls;
    if (frameId !== null) return;
    frameId = requestFrame(() => {
      frameId = null;
      if (disposed) return;
      const frameAdvancesControls = advanceControls;
      advanceControls = false;
      if (onFrame(frameAdvancesControls)) request(true);
    });
  };

  return {
    request,
    dispose: () => {
      disposed = true;
      if (frameId !== null) cancelFrame(frameId);
      frameId = null;
      advanceControls = false;
    },
  };
}
